export default function (props) {
  return (
    <label className="flex items-center container-checkbox">
      <div className={`flex items-center ${props.className} cursor-pointer`}>
        <input
          id={props.name}
          aria-describedby="comments-description"
          name={props.name}
          checked={props.checked}
          onChange={props.onChange}
          type="checkbox"
          className="checkbox"
        />
        <span className="checkmark" />
      </div>
      <span className="cursor-pointer ml-3">{props.label}</span>
    </label>
  );
}
